import React from 'react';
import { connect } from 'react-redux';
import style from './spinner.scss';

const SpinnerView = ({ children, showSpinner }) => (
    <React.Fragment>
        {children}
        {showSpinner
            && <div className={style.spinnerWrapper}>
                <div className={style.spinnerBackground}>
                    <div className={style.spinner} />
                </div>
            </div>
        }
    </React.Fragment>
);


const mapStateToProps = state => ({
    showSpinner: state.parts.fetching || state.caravans.fetching,
});

export default connect(mapStateToProps)(SpinnerView);
